import { setCookie, getCookie } from 'tiny-cookie';
import { getQueryStringParams } from 'lib/utils';
import { getStartMessage } from './startMessage';
import axios from 'axios';
import "clientjs";
const BrowserFingerprint = require("browser_fingerprint");

const params = getQueryStringParams();

export function generateId() {
  return Math.random().toString();
}

export async function sendMessage(message) {
  message = message.toLowerCase();

  console.log({
    ...getQueryStringParams(),
    messages: [
      {
        type: 'simpleMessage',
        text: message
      }
    ]
  }
  );

  const res = {
    meta: {
      ...getQueryStringParams()
    },
    data: {
      messages: []
    }
  };

  if (message === 'start') {
    res.data.messages = getStartMessage();
  }
  else {
    let fingerprint = getCookie('__chatbot');
    if (!fingerprint) {
      fingerprint = new ClientJS().getFingerprint();
      const date = new Date;
      date.setDate(date.getDate() + 21);
      setCookie('__chatbot', fingerprint.toString(), { expires: date });
    }
    const endpointUrl = params['serviceUrl'] || window.location.origin + "/dialogflowWebhook";
    const payload = {
      message: message,
      userId: params['session'] ? params['session'] : fingerprint.toString(),
      plataform: 'webfront', // mantendo grafia incorreta antiga para auxiliar na depreciação e troca para o correto
      platform: 'webfront',
      pageOrigin: params['page'],
      shoppingId: params['shoppingSlug'] ? params['shoppingSlug'] : 'ssu',
      shopping: params['shopping'], // mantendo nome antigo para auxiliar na depreciação e troca para o novo
    };

    const response = await axios.post(endpointUrl, payload);
    console.log("validação do deploy automatico do zeca front");

    if (response.data[response.data.length - 1].text === "#CONTENT_IDS") {
      // Checagem provisoria quando back ainda esta no modelo antigo sempre enviando '#CONTENT_IDS' como ultimo elemento
      res.data.messages = response.data.slice(0, response.data.length - 1);
    } else {
      res.data.messages = response.data;
    }

  }
  return res;
}
